import { Injectable, inject } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { State } from '@wam/shared';
import { JwtService } from './jwt.service';
import { authenticationSelectors } from './state/authentication.selectors';
import * as authenticationActions from './state/authentication.actions';
import { isReportsApp } from '@app/reports-app/reports-app.util';

@Injectable({
  providedIn: 'root',
})
export class IdTokenService {
  private store = inject<Store<State>>(Store);
  private jwtHelperService = inject(JwtService);

  private justRefreshed = false;

  getActiveIdToken(refreshOnExpiredToken = true): Observable<string> {
    // The standalone reports app validates the id token once at bootstrap and never
    // refreshes it.
    if (isReportsApp()) {
      refreshOnExpiredToken = false;
    }

    return combineLatest([
      this.store.pipe(select(authenticationSelectors.getIdToken)),
      this.store.pipe(select(authenticationSelectors.getPending)),
    ]).pipe(
      filter(([_, pending]) => !pending),
      // @ts-ignore
      map(([token]) => {
        if (refreshOnExpiredToken && this.jwtHelperService.isTokenExpired(token)) {
          if (this.justRefreshed) {
            this.store.dispatch(authenticationActions.logOut());
          } else {
            this.store.dispatch(authenticationActions.refreshToken());
            this.justRefreshed = true;
            return null;
          }
        } else {
          this.justRefreshed = false;
          return token;
        }
      }),
      filter((token) => token !== null),
    );
  }
}
